const toOptionalNumber = (value: unknown) => {
    if (value == null || value === '') return null

    const numericValue = Number(value)
    return Number.isFinite(numericValue) ? numericValue : null
}

const firstNumber = (...values: unknown[]) => {
    for (const value of values) {
        const numericValue = toOptionalNumber(value)
        if (numericValue != null) return numericValue
    }

    return null
}

/**
 * Returns the value expected by TimeTrackerPicker: hours.
 *
 * `spendTime` and `spend_time` are local UI fields already stored in hours.
 * Backend aggregates and time-log fields are stored in minutes and must be
 * converted exactly once here.
 */
export function getTaskSpentHours(task: any): number | null {
    const hoursSpent = firstNumber(
        task?.spendTime,
        task?.spend_time,
    )

    if (hoursSpent != null) return hoursSpent

    const minutesSpent = firstNumber(
        task?.time_log?.minutes_spent,
        task?.timeLog?.minutes_spent,
        task?.timeLog?.minutesSpent,
        task?.minutes_spent,
        task?.time_spent,
        task?.tracked_time,
        task?.time_tracking,
    )

    return minutesSpent == null ? null : minutesSpent / 60
}

/** Returns the read-only aggregate reported by the API, in minutes. */
export function getTaskTotalSpentMinutes(task: any): number {
    const totalMinutes = firstNumber(
        task?.total_time_spent,
        task?.totalTimeSpent,
    )

    return totalMinutes == null ? 0 : Math.max(0, totalMinutes)
}

export function formatTaskTotalSpentTime(task: any): string {
    const hours = getTaskTotalSpentMinutes(task) / 60
    const roundedHours = Number(hours.toFixed(2))
    const localizedHours = String(roundedHours).replace('.', ',')

    return `${localizedHours}ч`
}
